import PropTypes from 'prop-types';
import React from 'react';
import { Img as ReactImage } from 'react-image';

import placeholderImg from 'assets/placeholder.png';
import LoadBlur from 'components/LoadBlur';

const Image = ({ placeholderSrc, showLoading, ...props }) => {
  const placeholder = (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img {...props} src={placeholderSrc} />
  );
  return (
    <ReactImage
      {...props}
      loader={<LoadBlur loading={showLoading}>{placeholder}</LoadBlur>}
      unloader={placeholder}
    />
  );
};

Image.propTypes = {
  // ...ReactImage.propTypes,
  placeholderSrc: PropTypes.string,
  showLoading: PropTypes.bool,
};

Image.defaultProps = {
  placeholderSrc: placeholderImg,
  showLoading: true,
};

export default Image;
